import RetailerView from './components/RetailerView';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import has from 'lodash/has';
import get from 'lodash/get';
import {connect} from 'react-redux';

import {
  loadRetailer
} from '../../shared/redux/entities/actions'

function mapStateToProps(state,props){
  const retailerId = props.match.params.retailerId;

  return {
    retailerId:retailerId,
    needsLoading:!has(state,['entities','companies',retailerId,'name']),
    name:get(state,['entities','companies',retailerId,'name'])
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ loadRetailer },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(RetailerView));



// WEBPACK FOOTER //
// ./src/routes/RetailerView/index.js